import { Carousel } from 'antd'
import styled from 'styled-components'
import { COLORS } from '../../../tokens'

export const CalendarContainer = styled.div`
  width: 100%;
  height: 98%;
  color: ${COLORS.textPrimary};
  background: ${COLORS.background};
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderPrimary};
  position: relative;
  display: flex;
  flex-direction: column;

  overflow-y: hidden;

  @media (min-width: 1370px) {
    overflow-y: auto;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75%;
  width: 89%;
`

export const FixedHeaderSection = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  margin-bottom: 1px;
  display: flex;
  // margin-bottom: -20px;
`

export const HeaderRow = styled.div`
  display: grid;
  height: 59px;
  margin-top: -0.8px;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: none;
  min-width: 620px;
  flex: 1;
  color: ${COLORS.textSecondary};
  background: ${COLORS.background};
`

export const HeaderCell = styled.div`
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  border-bottom: 1px solid ${COLORS.borderPrimary};
  background: ${COLORS.background};
  color: ${COLORS.textPrimary};
  margin-top: 16px;
`

export const CountHeaderContainer = styled.div`
  width: 70px;
  height: 63px;
  position: relative;
  z-index: 0;
  margin-top: -10px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
`

export const CountHeaderText = styled.div`
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.textPrimary};
  border: 1px solid ${COLORS.borderPrimary};
  background: ${COLORS.background};
  border-radius: 4px;
  height: 40px;
  width: 63px;
  margin-left: -8px;
`
export const ScrollableGridContainer = styled.div`
  flex: 1;
  position: relative;

  overflow-y: hidden;
  overflow-x: hidden;

  @media (min-width: 1370px) {
    overflow-y: auto;
  }
`

export const MainContentContainer = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 30px;

  @media (min-width: 1370px) {
    overflow: visible;
  }
`

export const TimeColumnContainer = styled.div`
  width: 70px;
  flex-shrink: 1;
  postion: fixed;
  top: 0;
  left: 0;
`

export const CarouselContainer = styled.div`
  flex: 1;

  overflow-y: hidden;
  overflow-x: hidden;
`

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  min-width: 620px;
`

export const TimeCell = styled.div`
  height: 64px;
  font-weight: 500;
  position: relative;
  z-index: 1;
  font-size: 12px;
`

export const Time = styled.div`
  position: relative;
  top: -11px;
  left: 20px;
  z-index: 2;
  font-weight: 600;
`

export const CalendarCell = styled.div`
  height: 64px;
  padding-top: 2.5px;
  padding-right: 4px;
  padding-left: 4px;
  padding-bottom: 4.5px;
  border-bottom: 1px solid ${COLORS.borderPrimary};
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
  width: 100%;
  position: relative;

  &:nth-last-child(-n + 7) {
    border-bottom: none;
  }
`

export const QuarterRow = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  position: relative;
  z-index: 1;
`

/* Unbookable ("anti-schedule") range — no schedule set, booking impossible.
   The stripe pattern must stay continuous across overlays stacked in adjacent
   hour cells, so every overlay paints the same fixed-size gradient canvas and
   shifts it (via inline background-position) by its offset from the column top. */
export const BlockedSlotOverlay = styled.div`
  position: absolute;
  left: 4px;
  right: 4px;
  background-image: repeating-linear-gradient(-45deg, #007f7c1a 0px, #007f7c1a 5px, transparent 5px, transparent 10px);
  background-repeat: no-repeat;
  background-size: 100% 1600px;
  border-radius: 2px;
  z-index: 0;
  pointer-events: none;
`

export const StyledCarousel = styled(Carousel)`
  .slick-slide {
    overflow: hidden;
  }

  .slick-track {
    display: flex;
    align-items: flex-start;
  }
`

/* ----------- LIVE TIME INDICATOR ADDED HERE ----------- */
// export const LiveTimeIndicator = styled.div<{ top: number }>`
//   position: absolute;
//   left: 0;
//   right: 0;
//   height: 0;
//   border-top: 2px dotted ${COLORS.borderPrimary};
//   z-index: 20;
//   pointer-events: none;

//   span {
//     position: absolute;
//     left: -70px;
//     top: -8px;
//     background: ${COLORS.background};
//     padding: 2px 6px;
//     font-size: 12px;
//     font-weight: 500;
//   }
// `

// export const LiveTimeIndicator = styled.div<{ top: number }>`
//   position: absolute;
//   left: 0;
//   right: 0;
//   height: 0;
//   border-top: 2px dotted ${COLORS.borderPrimary};
//   z-index: 20;
//   pointer-events: none;

//   span {
//     position: absolute;
//     left: 20px; /* Align with Time component */
//     top: -8px;
//     background: transparent;
//     padding: 2px 6px;
//     font-size: 12px;
//     font-weight: 500;
//     white-space: nowrap;
//     color: ${COLORS.textPrimary};
//   }
// `

export const LiveTimeIndicator = styled.div<{ top: number }>`
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  z-index: 20;
  pointer-events: none;

  /* Line that starts after the time label */
  &::after {
    content: '';
    position: absolute;
    left: 80px; /* Start after the time column width */
    right: 0;
    border-top: 2px dotted ${COLORS.borderPrimary};
  }

  span {
    position: absolute;
    left: 20px; /* Align with Time component */
    top: -8px;
    background: none;
    padding: 2px 6px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    color: ${COLORS.textPrimary};
  }
`
